import axios from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const getCompanies = () => {
  return axios.get(`${serviceBaseUrl}/guests/companies`)
}

export const getGuestsByVendorId = ({ vendorId }) => {
  return axios.get(`${serviceBaseUrl}/guests/companies/${vendorId}`)
}
